import { _ } from "i18n";
import type { ColumnConfig } from "../../types";
import { DiscoverGamesGameUserDropdownCell } from "../cells/DiscoverGamesGameUserDropdownCell";
import {
	DiscoverGamesColumnField,
	DiscoverGamesUiColumnKey,
	DISCOVER_GAMES_COL_WIDTH_MANAGER,
} from "../constants";
import type { DiscoverGamesColumnsParams, GameRow } from "../types";

export function clubManagerColumn(p: DiscoverGamesColumnsParams): ColumnConfig<GameRow> {
	const clubManagerOptions = p.clubManagerOptions ?? [];
	return {
		key: DiscoverGamesUiColumnKey.ClubManager,
		label: _("discover.gamesTable.column.clubManager"),
		sortable: true,
		sortField: DiscoverGamesColumnField.ClubManagerName,
		minWidth: DISCOVER_GAMES_COL_WIDTH_MANAGER.min,
		maxWidth: DISCOVER_GAMES_COL_WIDTH_MANAGER.max,
		cell: (_, row) => (
			<DiscoverGamesGameUserDropdownCell
				row={row}
				displayName={row.clubManagerName}
				userId={row.clubManagerId}
				options={clubManagerOptions}
				isUpdating={p.isClubMetadataUpdating}
				onChange={p.canEditGameUploads ? p.onClubManagerChange : undefined}
				readOnlyTitle={p.tooltips?.cannotEditGameUploads}
			/>
		),
		group: _("discover.gamesTable.group.teams"),
		defaultVisible: true,
		requiredFields: [DiscoverGamesColumnField.ClubManagerId, DiscoverGamesColumnField.ClubManagerName],
	};
}

export function contentManagerColumn(p: DiscoverGamesColumnsParams): ColumnConfig<GameRow> {
	const contentManagerOptions = p.contentManagerOptions ?? [];
	return {
		key: DiscoverGamesUiColumnKey.ContentManager,
		label: _("discover.gamesTable.column.contentManager"),
		sortable: true,
		sortField: DiscoverGamesColumnField.ContentManagerName,
		minWidth: DISCOVER_GAMES_COL_WIDTH_MANAGER.min,
		maxWidth: DISCOVER_GAMES_COL_WIDTH_MANAGER.max,
		cell: (_, row) => (
			<DiscoverGamesGameUserDropdownCell
				row={row}
				displayName={row.contentManagerName}
				userId={row.contentManagerId}
				options={contentManagerOptions}
				isUpdating={p.isClubMetadataUpdating}
				onChange={p.canEditGameUploads ? p.onContentManagerChange : undefined}
				readOnlyTitle={p.tooltips?.cannotEditGameUploads}
			/>
		),
		group: _("discover.gamesTable.group.teams"),
		defaultVisible: true,
		requiredFields: [DiscoverGamesColumnField.ContentManagerId, DiscoverGamesColumnField.ContentManagerName],
	};
}

export function assigneeColumn(p: DiscoverGamesColumnsParams): ColumnConfig<GameRow> {
	const assigneeOptions = p.assigneeOptions ?? [];
	return {
		key: DiscoverGamesUiColumnKey.Assignee,
		label: _("discover.gamesTable.column.assignee"),
		sortable: true,
		sortField: DiscoverGamesColumnField.AssigneeName,
		minWidth: DISCOVER_GAMES_COL_WIDTH_MANAGER.min,
		maxWidth: DISCOVER_GAMES_COL_WIDTH_MANAGER.max,
		cell: (_, row) => (
			<DiscoverGamesGameUserDropdownCell
				row={row}
				displayName={row.assigneeName}
				userId={row.assigneeId}
				options={assigneeOptions}
				isUpdating={p.isClubMetadataUpdating}
				onChange={p.canEditAssignee ? p.onAssigneeChange : undefined}
				readOnlyTitle={p.tooltips?.cannotEditAssignee}
			/>
		),
		group: _("discover.gamesTable.group.teams"),
		defaultVisible: true,
		requiredFields: [DiscoverGamesColumnField.AssigneeId, DiscoverGamesColumnField.AssigneeName],
	};
}
